/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ErrorOutput,
  RedeemTrialCouponInput,
  SchemaValidationErrorResponse,
  TrialCouponResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Redeem a trial coupon code
 */
export const redeemTrialCoupon = (
    redeemTrialCouponInput?: MaybeRefOrGetter<RedeemTrialCouponInput>,
 signal?: AbortSignal
) => {
      redeemTrialCouponInput = toValue(redeemTrialCouponInput);

      return axiosClient<TrialCouponResponse>(
      {url: `/b2c/trial_coupons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: redeemTrialCouponInput, signal
    },
      );
    }




export const getRedeemTrialCouponMutationKey = () => ['redeemTrialCoupon'] as const;

export const getRedeemTrialCouponMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | ErrorOutput>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemTrialCoupon>>, TError,RedeemTrialCouponMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof redeemTrialCoupon>>, TError,RedeemTrialCouponMutationVariables, TContext> => {

const mutationKey = getRedeemTrialCouponMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemTrialCoupon>>, RedeemTrialCouponMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  redeemTrialCoupon(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedeemTrialCouponMutationResult = NonNullable<Awaited<ReturnType<typeof redeemTrialCoupon>>>
    export type RedeemTrialCouponMutationBody = RedeemTrialCouponInput | undefined
    export type RedeemTrialCouponMutationError = ErrorType<SchemaValidationErrorResponse | ErrorOutput>
    export type RedeemTrialCouponMutationVariables = {data?: RedeemTrialCouponInput}

    /**
 * @summary Redeem a trial coupon code
 */
export const useRedeemTrialCoupon = <TError = ErrorType<SchemaValidationErrorResponse | ErrorOutput>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemTrialCoupon>>, TError,RedeemTrialCouponMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof redeemTrialCoupon>>,
        TError,
        RedeemTrialCouponMutationVariables,
        TContext
      > => {
      return useMutation(getRedeemTrialCouponMutationOptions(options), queryClient);
    }
